// src/pages/Welcome.jsx
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./Welcome.css";

export default function Welcome() {
  const navigate = useNavigate();

  const {
    updateProfileAndCompleteOnboarding,
    refreshSession
  } = useAuth();

  const [firstName, setFirstName] = useState("");
  const [saving, setSaving] = useState(false);
  const [showConfetti, setShowConfetti] = useState(true);

  const canSave =
    firstName.trim().length >= 2 &&
    !saving;

  const displayName = useMemo(() => {
    return firstName.trim().replace(/\s+/g, " ").trim();
  }, [firstName]);

  useEffect(() => {
    const t = setTimeout(() => setShowConfetti(false), 1600);
    return () => clearTimeout(t);
  }, []);

  const onSave = async () => {
    if (!canSave) return;

    setSaving(true);

    try {
      await updateProfileAndCompleteOnboarding({
        name: displayName
      });

      if (refreshSession) {
        await refreshSession();
      }

      navigate("/dashboard", { replace: true });
    } catch (err) {
      console.error(err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <main className="zw-page">

      {showConfetti && (
        <div className="zw-confetti-container" aria-hidden="true">
          {Array.from({ length: 40 }).map((_, i) => {
            // Generamos valores aleatorios para cada pieza
            const velocity = Math.random() * 100 + 50; // Fuerza de la explosión
            const angle = Math.random() * 360; // Dirección (círculo completo)
      
            return (
              <span
                key={i}
                className="zw-confetti-piece"
                style={{
                  '--velocity': `${velocity * 2.2}px`,
                  '--angle': `${angle}deg`,
                  '--bg-color': ['#CCA352', 'rgba(40,107,148,.38)', 'rgba(18,54,77,.24)', '#E9DFC7'][Math.floor(Math.random() * 4)],
                  animationDelay: `${Math.random() * 0.2}s`, // Un pequeño desfase para realismo
                }}
              />
            );
          })}
        </div>
      )}

      <section className="zw-card">
        <header className="zw-header">
          <h1 className="zw-title">Personaliza tu experiencia</h1>
          <p className="zw-subtitle">
            ¿Cómo te gusta que te llamemos?
          </p>
        </header>

        <div className="zw-form">
          <label className="zw-field">
            <input
              className="zw-input"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              placeholder="Escribe tu nombre"
            />
          </label>

          <button
            type="button"
            className="zw-btn"
            onClick={onSave}
            disabled={!canSave}
          >
            {saving ? "Guardando…" : "Guardar y continuar"}
          </button>

          <p className="zw-legal">
            <Link to="/legal/terminos">Términos</Link> y{" "}
            <Link to="/legal/privacidad">Privacidad</Link>
          </p>
        </div>
      </section>
    </main>
  );
}